module.exports = __webpack_public_path__ + "img/en.c25cda54.png";